import { bus } from "@/main";

export default {
	data() {
		return{
			title: "Porto Design Biennale",
			titleRendered: null,
		}
	},
	props: [
		"type",
		"uppercase",
		"width",
		"weight",
		"random",
	],
	created() {
		this.titleSplit();

		function throttleWithTime(action, wait) {
			let time = Date.now();
			return function () {
				if ((time + wait - Date.now()) < 0) {
					action();
					time = Date.now();
				}
			}
		}
		
		window.addEventListener("mousemove", event => {
			throttleWithTime(this.onMouseMove(), 1000);
		});
	},
	methods: {
		titleSplit() {
			this.titleRendered = this.title.split('');
		},
		onMouseMove() {
			let logo = this.$el.children[0];
			
			let width = (event.pageX / this.width) * window.innerWidth;
			let weight = (event.pageY / window.innerHeight) * this.weight;
			
			console.log("Wight", weight)

			if(this.width && this.weight){
				logo.style.fontWeight = weight;
				// logo.style.fontVariationSettings = `"wght" ${weight}, "wdth" ${width}`;
			}
			else{
				logo.style.fontWeight = weight;
				// logo.style.fontVariationSettings = `"wght" ${weight}`;
			}
			
			// for (var j = 0; j < logo.length; j++) {
			// 	console.log("Logo", logo[j])
			// 	logo[j].style.fontVariationSettings = `"wght" ${weight}, "wdth" ${width}`
			// }
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/blocks/logo-block/logo.block.js